import React from "react";
import Banner from "./Banner";
import Popular from "./Popular";
import Offers from "./Offers";
import NewCollections from "./NewCollections";
import NewsLetters from "./NewsLetters";

const Shop = () => {
  return (
    <div>
      <Banner />
      <Popular />
      <Offers />
      <NewCollections />
      <NewsLetters />
    </div>
  );
};

export default Shop;
